/* eslint-disable no-console */
import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { CustomProvider } from 'rsuite'
import { Loader } from 'shared'
import store from 'store/store'
import reportWebVitals from './reportWebVitals'
import App from './App'
import './scss/app.scss'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <Suspense fallback={<Loader />}>
      <CustomProvider theme="light">
        <Provider store={store}>
          <App />
        </Provider>
      </CustomProvider>
    </Suspense>
  </React.StrictMode>
)

reportWebVitals()
